// src/lib/section.ts

/** A route name: lowercase letters and hyphens. Anything else (an id, an
 *  email typed into the URL, a stray catch-all path) collapses to `other`, so
 *  the analytics dimension stays bounded and carries no user data. */
const SECTION_NAME = /^[a-z][a-z-]{0,23}$/

/** First path segment, the unit an ad reload on navigation would key on:
 *  `/bracket?deck=x` and `/bracket` are one section, `/` is `home`. */
export function sectionOf(pathname: string): string {
  const first = pathname.split('/').filter(Boolean)[0]?.toLowerCase()
  // eslint-disable-next-line i18next/no-literal-string -- analytics value
  if (!first) return 'home'
  // eslint-disable-next-line i18next/no-literal-string -- analytics value
  return SECTION_NAME.test(first) ? first : 'other'
}
